import { Box, CircularProgress, Grid } from '@mui/material';

export const PendingUploadsMessage = () => {
  return (
    <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: '6px' }}>
      <CircularProgress size={10} />
      <Box component={'span'} sx={{ fontSize: '10px', fontFamily: 'Inter' }}>
        Some uploads are still processing and will appear once they're finished.
      </Box>
    </Grid>
  );
};
